import styled, { css } from 'styled-components'

export const Container = styled.div<{ $isDisabled: boolean }>`
  ${(props) =>
    props.$isDisabled &&
    css`
      opacity: 0.4;
    `}
`

export const Label = styled.label<{ $isDisabled: boolean }>`
  display: flex;
  gap: 20px;
  ${({ theme }) => theme.textStyles.text}
  cursor: pointer;

  ${(props) =>
    props.$isDisabled &&
    css`
      cursor: not-allowed;
    `}
`

export const LabelText = styled.p<{ $required: boolean; $isError?: boolean }>`
  ${({ theme }) => theme.textStyles.body};
  ${(props) =>
    props.$required &&
    css`
      &:after {
        content: ' *';
        color: ${(props) => props.theme.colors.red};
      }
    `}

  ${(props) =>
    props.$isError &&
    css`
      color: ${props.theme.colors.red};
    `}

  & a {
    color: ${(props) => props.theme.colors.pureBlack};
    text-decoration: underline;
  }
`

export const Checkbox = styled.input<{ $isError?: boolean }>`
  position: relative;
  appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid ${({ theme }) => theme.colors.pureBlack};
  margin: 1px 0 0 0;
  cursor: pointer;
  border-radius: 0;
  flex-shrink: 0;

  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
  ${(props) =>
    props.$isError &&
    css`
      border-color: ${props.theme.colors.red};
    `}
  &::before {
    content: '';
    display: inline-block;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    opacity: 0;
    transition: all 0.1s ease-out;
    background-color: ${({ theme }) => theme.colors.pureBlack};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:checked::before {
    opacity: 1;
  }
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.tiny};
  color: ${({ theme }) => theme.colors.red};
  margin-top: 5px;
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.tiny};
  color: grey;
  margin-top: 5px;
`
